import * as React from 'react';
import classnames from 'classnames';
import styled, { css, keyframes } from 'styled-components';
import { selectFromTheme, selectFromMap, selectFromProps, stylesFromMap } from '@thisisbud/sc-utils';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _endsWithInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/ends-with';
import { jsx, jsxs } from 'react/jsx-runtime';

let _$3 = t => t,
  _t$3;
// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledIconWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledIconWrapper",
  componentId: "sc-uzwh93-0"
})(_t$3 || (_t$3 = _$3`
  position: relative;
  display: inline-block;
  width: ${0};
  height: 1em;
  line-height: 1em;
  vertical-align: middle;

  .bui-icon {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-55%);
  }
`), "1.5em");

/**
 * Wraps any icons with an `<span>` to avoid label overflow.
 *
 * @param children - The component children
 */
function wrapLabelIcons(children) {
  var _context;
  return _mapInstanceProperty(_context = React.Children).call(_context, children, function (child) {
    if (typeof child === 'object') {
      const {
        type: {
          displayName
        }
      } = child;
      if (typeof displayName === 'string' && _endsWithInstanceProperty(displayName).call(displayName, 'Icon')) {
        return /*#__PURE__*/jsx(StyledIconWrapper, {
          children: child
        });
      }
    }
    return child;
  });
}

let _$2 = t => t,
  _t$2,
  _t2$2,
  _t3$2,
  _t4$2,
  _t5$2,
  _span;
const buttonClassName = 'bui-btn';
const buttonLabelClassName = 'bui-btn-label';
const buttonProgressClassName = 'bui-btn-progress';
const buttonProgressDotClassName = 'bui-btn-progress-dot';
const buttonLeftAlign = `${buttonClassName}--left`;
const buttonCenterAlign = `${buttonClassName}--center`;
const buttonRightAlign = `${buttonClassName}--right`;
const progressAnimation = /*#__PURE__*/keyframes(_t$2 || (_t$2 = _$2`
  0% {
    opacity: 1;
  }

  90% {
    opacity: 0.6;
  }

  100% {
    opacity: 1;
  }
`));
const buttonCommonCss$2 = /*#__PURE__*/css(_t2$2 || (_t2$2 = _$2`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  border-style: solid;
  box-sizing: border-box;
  text-decoration: none;
  cursor: pointer;

  &::before {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    box-sizing: content-box;
    border-width: ${0};
    border-style: solid;
    border-color: transparent;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &:hover {
    text-decoration: none;
  }

  &:focus {
    text-decoration: none;
    outline: none;

    &::before {
      opacity: 1;
    }
  }

  a&:not([href]):focus::before {
    opacity: 0;
  }

  &:disabled,
  a&:not([href]) {
    cursor: default;
  }

  * + & {
    margin-top: ${0};
  }

  & + .${0} {
    margin-top: ${0};
  }

  .${0} {
    display: block;
    width: 100%;
    text-align: center;
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
  }

  .${0} {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease-in-out;
  }

  .${0} {
    position: absolute;
    display: block;
    width: ${0};
    height: ${0};
    left: 50%;
    top: 50%;
    border-radius: 50%;
    background-color: currentColor;

    :nth-child(1) {
      transform: translate(-200%, -50%);
    }

    :nth-child(2) {
      transform: translate(0, -50%);
    }

    :nth-child(3) {
      transform: translate(200%, -50%);
    }
  }

  &[data-busy=true] {
    cursor: wait;

    .${0} {
      opacity: 0;
    }

    .${0} {
      pointer-events: auto;
      opacity: 1;
    }

    .${0} {
      :nth-child(1),
      :nth-child(2),
      :nth-child(3) {
        animation: ${0} 0.8s linear infinite;

        @media (prefers-reduced-motion) {
          animation: ${0} 2s linear infinite;
        }
      }
  
      :nth-child(2) {
        animation-delay: 0.2s;
      }
  
      :nth-child(3) {
        animation-delay: 0.4s;
      }
    }
  }

  &.${0} {
    margin-left: 0;
    margin-right: auto;
  }

  &.${0} {
    margin-left: auto;
    margin-right: auto;
  }

  &.${0} {
    margin-left: auto;
    margin-right: 0;
  }

  @media (min-width: ${0}) {
    max-width: ${0};
  }
`), "0.1875rem", selectFromTheme('spacingLargeDefault'), buttonClassName, selectFromTheme('spacingXSmallDefault'), buttonLabelClassName, buttonProgressClassName, buttonProgressDotClassName, "0.5rem", "0.5rem", buttonLabelClassName, buttonProgressClassName, buttonProgressDotClassName, progressAnimation, progressAnimation, buttonLeftAlign, buttonCenterAlign, buttonRightAlign, selectFromTheme('breakpointMedium'), selectFromTheme('maxWidthConstrictorNarrowDefault'));

/**
 * Get the CSS for a specific button variant.
 *
 * @param variant - The button style variant
 */
function getButtonCss$1(variant) {
  // eslint-disable-line max-lines-per-function
  return css(_t3$2 || (_t3$2 = _$2`
  background-color: ${0};
  border-color: ${0};
  border-radius: ${0};
  border-width: ${0};
  color: ${0};
  font-family: ${0};
  font-size: ${0};
  font-weight: ${0};
  letter-spacing: ${0};
  line-height: ${0};
  text-transform: ${0};
  padding: ${0};
  transition: background-color 0.2s ease-in-out;

  &::before {${0}
    border-radius: ${0};
  }

  &:hover {
    background-color: ${0};
    border-color: ${0};
    color: ${0};
  }

  &:hover::before {${0}}

  &:active {
    background-color: ${0};
    border-color: ${0};
    color: ${0};
  }

  &:disabled,
  a&:not([href]) {
    background-color: ${0};
    border-color: ${0};
    color: ${0};
  }

  &:disabled[data-busy=true],
  a&[data-busy=true] {
    background-color: ${0};
    border-color: ${0};
    color: ${0};
  }
`), selectFromTheme(`colorBackgroundButton${variant}Default`), selectFromTheme(`colorBorderButton${variant}Default`), selectFromTheme(`borderRadiusButton${variant}Default`), selectFromTheme(`borderWidthButton${variant}Default`), selectFromTheme(`colorTextButton${variant}Default`), selectFromTheme(`fontFamilyButton${variant}`), selectFromTheme(`fontSizeButton${variant}Default`), selectFromTheme(`fontWeightButton${variant}`), selectFromTheme(`letterSpacingButton${variant}Default`), selectFromTheme(`lineHeightButton${variant}Default`), selectFromTheme(`textTransformButton${variant}`), selectFromMap(selectFromProps('$compact'), {
    false: selectFromTheme(`paddingButton${variant}Default`),
    true: selectFromTheme(`paddingButton${variant}CompactDefault`)
  }), function (props) {
    const theme = props.theme;
    const outlineColor = theme[`colorBorderButton${variant}Default`];
    const outlineWidth = theme[`outlineWidthButton${variant}Default`];
    if (Boolean(outlineWidth) && Boolean(outlineColor)) {
      return `box-shadow: 0 0 0 ${outlineWidth} ${outlineColor};`;
    }
    return '';
  }, selectFromTheme(`borderRadiusButton${variant}Default`), selectFromTheme(`colorBackgroundButton${variant}Hover`), selectFromTheme(`colorBorderButton${variant}Hover`), selectFromTheme(`colorTextButton${variant}Hover`), function (props) {
    const theme = props.theme;
    const outlineColor = theme[`colorBorderButton${variant}Hover`];
    const outlineWidth = theme[`outlineWidthButton${variant}Default`];
    if (Boolean(outlineWidth) && Boolean(outlineColor)) {
      return `box-shadow: 0 0 0 ${outlineWidth} ${outlineColor};`;
    }
    return '';
  }, selectFromTheme(`colorBackgroundButton${variant}Active`), selectFromTheme(`colorBorderButton${variant}Active`), selectFromTheme(`colorTextButton${variant}Active`), selectFromTheme(`colorBackgroundButton${variant}Disabled`), selectFromTheme(`colorBorderButton${variant}Disabled`), selectFromTheme(`colorTextButton${variant}Disabled`), selectFromTheme(`colorBackgroundButton${variant}Default`), selectFromTheme(`colorBorderButton${variant}Default`), selectFromTheme(`colorTextButton${variant}Default`));
}
const buttonPrimaryCss$1 = getButtonCss$1('Primary');
const buttonSecondaryCss = getButtonCss$1('Secondary');
const buttonDestructiveCss$1 = getButtonCss$1('Destructive');

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledButton$2 = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledButton",
  componentId: "sc-lpdpv1-0"
})(_t4$2 || (_t4$2 = _$2`
  ${0}
  ${0}
`), buttonCommonCss$2, selectFromMap(selectFromProps('$variant'), {
  destructive: buttonDestructiveCss$1,
  primary: buttonPrimaryCss$1,
  secondary: buttonSecondaryCss
}));

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledAnchor$2 = /*#__PURE__*/styled.a.withConfig({
  displayName: "StyledAnchor",
  componentId: "sc-lpdpv1-1"
})(_t5$2 || (_t5$2 = _$2`
  ${0}
  ${0}
`), buttonCommonCss$2, selectFromMap(selectFromProps('$variant'), {
  destructive: buttonDestructiveCss$1,
  primary: buttonPrimaryCss$1,
  secondary: buttonSecondaryCss
}));

/**
 * Prevent an event from performing the default action.
 *
 * @param e - The event object
 */
function noop(e) {
  e.preventDefault();
}
function renderProgress() {
  return _span || (_span = /*#__PURE__*/jsxs("span", {
    className: buttonProgressClassName,
    children: [/*#__PURE__*/jsx("span", {
      className: buttonProgressDotClassName
    }), /*#__PURE__*/jsx("span", {
      className: buttonProgressDotClassName
    }), /*#__PURE__*/jsx("span", {
      className: buttonProgressDotClassName
    })]
  }));
}

/**
 * Render the Button component as a `button` tag.
 *
 * @param props - The component props
 * @param className - The class name of the root element
 * @param children - The children of the root element
 */
function renderButton$2(props, className, children) {
  const {
    busy,
    compact,
    disabled,
    id,
    name,
    onClick,
    type,
    value,
    variant
  } = props;
  return /*#__PURE__*/jsxs(StyledButton$2, {
    $compact: compact,
    $variant: variant,
    className: className,
    "data-busy": busy,
    disabled: disabled === true || busy === true,
    id: id,
    name: name,
    tabIndex: 0,
    type: type,
    value: value,
    onClick: onClick,
    children: [children, renderProgress()]
  });
}

/**
 * Render the Button component as an `a` tag.
 *
 * @param props - The component props
 * @param className - The class name of the root element
 * @param children - The children of the root element
 */
function renderAnchor$2(props, className, children) {
  const {
    busy,
    compact,
    disabled,
    download,
    href,
    id,
    onClick,
    rel,
    target,
    variant
  } = props;
  return /*#__PURE__*/jsxs(StyledAnchor$2, {
    $compact: compact,
    $variant: variant,
    "aria-disabled": disabled === true || busy === true,
    className: className,
    "data-busy": busy,
    download: download,
    href: disabled === true ? undefined : href,
    id: id,
    rel: rel,
    tabIndex: disabled === true ? -1 : 0,
    target: target,
    onClick: disabled === true || busy === true ? noop : onClick,
    children: [children, renderProgress()]
  });
}

/**
 * A button component with 3 different variants to fit different needs.
 *
 * This is a polymorphic component and depending on the value of `type` it will either render as a `button` or `a` element.
 * Depending on the value of `type` different props will be used.
 *
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { Button } from '@thisisbud/bui-react-button'
 *
 * function Example() {
 *   return (
 *     <Button href='https://www.thisisbud.com' target='_blank' type='anchor'>
 *       Visit Bud's website
 *     </Button>
 *   )
 * }
 * ```
 */
function Button(props) {
  const {
    align,
    children,
    className,
    type,
    variant
  } = props;
  const computedClassName = classnames(buttonClassName, `${buttonClassName}--${variant}`, `${buttonClassName}--${align}`, className);
  const inner = /*#__PURE__*/jsx("span", {
    className: buttonLabelClassName,
    children: wrapLabelIcons(children)
  });
  if (type === 'anchor') {
    return renderAnchor$2(props, computedClassName, inner);
  }
  return renderButton$2(props, computedClassName, inner);
}
Button.defaultProps = {
  align: 'left',
  compact: false,
  type: 'button',
  variant: 'primary'
};
Button.displayName = 'Button';

let _$1 = t => t,
  _t$1,
  _t2$1,
  _t3$1,
  _t4$1,
  _t5$1,
  _t6,
  _t7;
const textButtonClassName = 'bui-text-btn';

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledWrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledWrapper",
  componentId: "sc-w65s4l-0"
})(_t$1 || (_t$1 = _$1`
  display: flex;
  justify-content: ${0};

  & > div {
    position: relative;
    display: flex;
  }

  * + & {
    margin-top: ${0};
  }
`), function (props) {
  return props.$align;
}, selectFromTheme('spacingXXSmallDefault'));
const buttonCommonCss$1 = /*#__PURE__*/css(_t2$1 || (_t2$1 = _$1`
  position: relative;
  display: flex;
  padding: 0;
  border: 0;
  box-sizing: border-box;
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;
  transition: color 0.2s ease-in-out;
  z-index: 1;

  &:hover {
    text-decoration: none;
  }

  &:focus {
    text-decoration: none;
    outline: none;
  }

  &:disabled {
    cursor: default;
  }
`));

/**
 * Get the CSS for a specific button variant.
 *
 * @param variant - The button style variant
 */
function getButtonCss(variant) {
  return css(_t3$1 || (_t3$1 = _$1`
  color: ${0};
  font-family: ${0};
  font-size: ${0};
  font-weight: ${0};
  letter-spacing: ${0};
  line-height: ${0};
  text-transform: ${0};

  &:hover {
    color: ${0};
  }

  &:active {
    color: ${0};
  }

  &:disabled {
    color: ${0};
  }
`), selectFromTheme(`colorTextTextButton${variant}Default`), selectFromTheme(`fontFamilyTextButton${variant}`), selectFromTheme(`fontSizeTextButton${variant}Default`), selectFromTheme(`fontWeightTextButton${variant}`), selectFromTheme(`letterSpacingTextButton${variant}Default`), selectFromTheme(`lineHeightTextButton${variant}Default`), selectFromTheme(`textTransformButton${variant}`), selectFromTheme(`colorTextTextButton${variant}Hover`), selectFromTheme(`colorTextTextButton${variant}Active`), selectFromTheme(`colorTextTextButton${variant}Disabled`));
}
const buttonPrimaryCss = getButtonCss('Primary');
const buttonDestructiveCss = getButtonCss('Destructive');

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledButtonLabel = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledButtonLabel",
  componentId: "sc-w65s4l-1"
})(_t4$1 || (_t4$1 = _$1`
  display: block;
  width: 100%;
  text-align: center;
`));

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledUnderline = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledUnderline",
  componentId: "sc-w65s4l-2"
})(_t5$1 || (_t5$1 = _$1`
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  padding-bottom: ${0};
  border: 0;
  border-style: solid;
  opacity: 0;
  transition: border-color 0.2s ease-in-out, opacity 0.2s ease-in-out;
  z-index: 0;
  ${0}

  button:focus + &,
  a:focus + & {
    opacity: 1;
  }

  button:hover + &,
  a:hover + & {
  ${0}
  }
`), selectFromTheme('spacingXXXSmallDefault'), selectFromMap(selectFromProps('$variant'), {
  destructive: stylesFromMap({
    'border-bottom-width': selectFromTheme('underlineWidthTextButtonDestructiveDefault'),
    // eslint-disable-line @typescript-eslint/naming-convention
    'border-color': selectFromTheme('colorTextTextButtonDestructiveDefault') // eslint-disable-line @typescript-eslint/naming-convention
  }),

  primary: stylesFromMap({
    'border-bottom-width': selectFromTheme('underlineWidthTextButtonPrimaryDefault'),
    // eslint-disable-line @typescript-eslint/naming-convention
    'border-color': selectFromTheme('colorTextTextButtonPrimaryDefault') // eslint-disable-line @typescript-eslint/naming-convention
  })
}), selectFromMap(selectFromProps('$variant'), {
  destructive: stylesFromMap({
    'border-color': selectFromTheme('colorTextTextButtonDestructiveHover') // eslint-disable-line @typescript-eslint/naming-convention
  }),

  primary: stylesFromMap({
    'border-color': selectFromTheme('colorTextTextButtonPrimaryHover') // eslint-disable-line @typescript-eslint/naming-convention
  })
}));

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledButton$1 = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledButton",
  componentId: "sc-w65s4l-3"
})(_t6 || (_t6 = _$1`
  ${0}
  ${0}
`), buttonCommonCss$1, selectFromMap(selectFromProps('$variant'), {
  destructive: buttonDestructiveCss,
  primary: buttonPrimaryCss
}));

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledAnchor$1 = /*#__PURE__*/styled.a.withConfig({
  displayName: "StyledAnchor",
  componentId: "sc-w65s4l-4"
})(_t7 || (_t7 = _$1`
  ${0}
  ${0}
`), buttonCommonCss$1, selectFromMap(selectFromProps('$variant'), {
  destructive: buttonDestructiveCss,
  primary: buttonPrimaryCss
}));

/**
 * Render the Button component as a `button` tag.
 *
 * @param props - The component props
 * @param children - The children of the root element
 */
function renderButton$1(props, children) {
  const {
    disabled,
    id,
    name,
    onClick,
    type,
    value,
    variant
  } = props;
  return /*#__PURE__*/jsx(StyledButton$1, {
    $variant: variant,
    disabled: disabled,
    id: id,
    name: name,
    tabIndex: 0,
    type: type,
    value: value,
    onClick: onClick,
    children: children
  });
}

/**
 * Render the Button component as an `a` tag.
 *
 * @param props - The component props
 * @param children - The children of the root element
 */
function renderAnchor$1(props, children) {
  const {
    download,
    href,
    id,
    onClick,
    rel,
    target,
    variant
  } = props;
  return /*#__PURE__*/jsx(StyledAnchor$1, {
    $variant: variant,
    download: download,
    href: href,
    id: id,
    rel: rel,
    tabIndex: 0,
    target: target,
    onClick: onClick,
    children: children
  });
}

/**
 * A text button component with 2 different variants to fit different needs.
 *
 * This is a polymorphic component and depending on the value of `type` it will either render as a `button` or `a` element.
 * Depending on the value of `type` different props will be used.
 *
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { TextButton } from '@thisisbud/bui-react-button'
 *
 * function Example() {
 *   return (
 *     <TextButton href='https://www.thisisbud.com' target='_blank' type='anchor'>
 *       Visit Bud's website
 *     </TextButton>
 *   )
 * }
 * ```
 */
function TextButton(props) {
  const {
    align,
    children,
    className,
    type,
    variant
  } = props;
  const computedClassName = classnames(textButtonClassName, `${textButtonClassName}--${variant}`, className);
  const inner = /*#__PURE__*/jsx(StyledButtonLabel, {
    children: wrapLabelIcons(children)
  });
  return /*#__PURE__*/jsx(StyledWrapper$1, {
    $align: align,
    className: computedClassName,
    children: /*#__PURE__*/jsxs("div", {
      children: [type === 'anchor' ? renderAnchor$1(props, inner) : renderButton$1(props, inner), /*#__PURE__*/jsx(StyledUnderline, {
        $variant: variant
      })]
    })
  });
}
TextButton.defaultProps = {
  align: 'left',
  type: 'button',
  variant: 'primary'
};
TextButton.displayName = 'TextButton';

let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _StyledOutline;
const iconButtonClassName = 'bui-icon-btn';

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledWrapper",
  componentId: "sc-pttlm5-0"
})(_t || (_t = _`
  position: relative;
  display: flex;
  width: ${0};
  height: ${0};
`), "1.5rem", "1.5rem");
const buttonCommonCss = /*#__PURE__*/css(_t2 || (_t2 = _`
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  font-size: 1rem;
  border: 0;
  color: ${0};
  box-sizing: border-box;
  background-color: transparent;
  text-decoration: none;
  cursor: pointer;
  z-index: 1;

  &:hover {
    color: ${0};
    text-decoration: none;
  }

  &:active {
    color: ${0};
  }

  &:focus {
    text-decoration: none;
    outline: none;
  }
  
  &:disabled {
    color: ${0};
    cursor: default;
  }

  .bui-icon {
    display: block;
  }
`), selectFromTheme('colorIconButtonDefault'), selectFromTheme('colorIconButtonHover'), selectFromTheme('colorIconButtonActive'), selectFromTheme('colorIconButtonDisabled'));

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledOutline = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledOutline",
  componentId: "sc-pttlm5-1"
})(_t3 || (_t3 = _`
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  box-sizing: content-box;
  border-style: solid;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: border-color 0.2s ease-in-out, opacity 0.2s ease-in-out;
  z-index: 0;
  border-color: ${0};
  border-radius: ${0};
  border-width: ${0};
  padding: ${0};

  button:focus + &,
  a:focus + & {
    opacity: 1;
  }

  button:hover + &,
  a:hover + & {
    border-color: ${0};
  }
`), selectFromTheme('colorIconButtonDefault'), selectFromTheme('borderRadiusIconButtonDefault'), selectFromTheme('borderWidthIconButtonDefault'), selectFromTheme('paddingIconButtonDefault'), selectFromTheme('colorIconButtonHover'));

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledButton",
  componentId: "sc-pttlm5-2"
})(_t4 || (_t4 = _`
  ${0}
`), buttonCommonCss);

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledAnchor = /*#__PURE__*/styled.a.withConfig({
  displayName: "StyledAnchor",
  componentId: "sc-pttlm5-3"
})(_t5 || (_t5 = _`
  ${0}
`), buttonCommonCss);

/**
 * Render the Button component as a `button` tag.
 *
 * @param props - The component props
 */
function renderButton(props) {
  const {
    children,
    disabled,
    id,
    name,
    onClick,
    type,
    value
  } = props;
  return /*#__PURE__*/jsx(StyledButton, {
    disabled: disabled,
    id: id,
    name: name,
    tabIndex: 0,
    type: type,
    value: value,
    onClick: onClick,
    children: children
  });
}

/**
 * Render the Button component as an `a` tag.
 *
 * @param props - The component props
 */
function renderAnchor(props) {
  const {
    children,
    download,
    href,
    id,
    onClick,
    rel,
    target
  } = props;
  return /*#__PURE__*/jsx(StyledAnchor, {
    download: download,
    href: href,
    id: id,
    rel: rel,
    tabIndex: 0,
    target: target,
    onClick: onClick,
    children: children
  });
}

/**
 * A button component to display a clickable icon.
 *
 * This is a polymorphic component and depending on the value of `type` it will either render as a `button` or `a` element.
 * Depending on the value of `type` different props will be used.
 *
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { IconButton } from '@thisisbud/bui-react-button'
 * import { CloseIcon } from '@thisisbud/bui-react-icons'
 *
 * function Example() {
 *   return (
 *     <IconButton>
 *       <CloseIcon label='Close dialog window'/>
 *     </IconButton>
 *   )
 * }
 * ```
 */
function IconButton(props) {
  const {
    className,
    type
  } = props;
  return /*#__PURE__*/jsxs(StyledWrapper, {
    className: classnames(iconButtonClassName, className),
    children: [type === 'anchor' ? renderAnchor(props) : renderButton(props), _StyledOutline || (_StyledOutline = /*#__PURE__*/jsx(StyledOutline, {}))]
  });
}
IconButton.displayName = 'IconButton';

export { Button, IconButton, TextButton, buttonClassName, iconButtonClassName, textButtonClassName };
